import React, { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  getDevice,
  getDeviceUsagebyId,
  getFirmwareHistory,
  getOnboardedHistory,
  getReportbyId,
  getDiagnosticsData,
} from "../../action/report";
import DeviceDetails from "../device/DeviceDetails";
import customConfig from "../../config";
import { Box, Divider } from "@mui/material";
import Dialog from "../Common/Dailog/Dailog";
import { SectionHeading, LabelText } from "../Common/Typography/AppTypography";
import DeviceUpdateLogs from "./../device/DeviceUpdateLogs";
import DeviceDiagnostics from "../device/DeviceDiagnostics/DeviceDiagnostics";
import DeviceConnDisconnLogs from "../device/DeviceConnDisconn/DeviceConnDisconnLogs";
import {
  downloadDeviceDiagnosticReport,
  downloadDeviceStatusReport,
  getDeviceConnDisconnLogsData,
  getDeviceDACLogsData,
  getDeviceDiagnosticsData,
  getDeviceStatusData,
} from "../../action/devicelogs";
import DeviceStatus from "../device/DeviceStatus/DeviceStatus";
import { getFormatedJSON } from "../../utils/general";
import { getDeviceLogPermission } from "../device/DeviceLogsConstants";
import DeviceDACLogs from "../device/DACStatistics/DeviceDACLogs/DeviceDACLogs";
import AppTabs from "../Common/Tabs/AppTabs";
import AppButton from "../Common/Button/Button";
import "../device/DeviceDetails.css";

const ReportDevices = ({
  user: { user, umV1AuthToken },
  tenant: { tenantInfo },
  userRoleInfo,
  getDeviceDiagnosticsData,
  downloadDeviceDiagnosticReport,
  getDeviceConnDisconnLogsData,
  getDeviceDACLogsData,
  downloadDeviceStatusReport,
  getDeviceStatusData,
  getDevice,
  report: {
    device,
    deviceUsage,
    latestFirmwareData,
    firmwareData,
    onBoardedHistoryData,
    diagnosticData,
    deviceLogs,
  },
  selectedData,
  getDeviceUsagebyId,
  getFirmwareHistory,
  getOnboardedHistory,
  getDiagnosticsData,
  getReportbyId,
  homeId,
}) => {
  const tabs = [
    { label: "Device Info", permission: "deviceInfo" },
    { label: "DAC Logs", permission: "dacLogs" },
    { label: "Device Logs", permission: "deviceLogs" },
    { label: "Connection Status Logs", permission: "connectionStatusLogs" },
    { label: "Diagnostic Logs", permission: "diagnosticLogs" },
    { label: "Status Logs", permission: "statusLogs" },
  ];

  const [Id, setId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [activeTab, setActiveTab] = React.useState(0);
  const [dialog, setDialog] = useState(false);
  const [dialogContents, setDialogContents] = useState({
    title: "",
    data: {},
  });
  const [availableTabs, setAvailableTabs] = React.useState([]);
  const [selectedTab, setSelectedTab] = React.useState(availableTabs[0]);

  useEffect(() => {
    setId(null);
  }, [selectedData]);

  useEffect(() => {
    const visibleTabs = tabs
      ?.filter((t) => getDeviceLogPermission(userRoleInfo?.roles, t?.permission))
      ?.map((t) => t?.label);
    setAvailableTabs(visibleTabs);
    setSelectedTab(visibleTabs[0]);
  }, [userRoleInfo?.roles]);

  const viewAcDetails = (tab) => {
    if (isEdit) return null;
    getDevice(
      tab.deviceId,
      customConfig.deviceSearchByDeviceId,
      userRoleInfo,
      umV1AuthToken,
      tenantInfo.tenantId
    );
    setId(tab.deviceId);
    getFirmwareHistory(tab.deviceId);
    getDeviceUsagebyId(tab.deviceId);
    getOnboardedHistory(tab.deviceId);
  };

  const handleNotifyOffboard = () => {
    getReportbyId(homeId);
  };

  const getDeviceIconClass = (category) => {
    const map = {
      AC: "smart-room-ac",
      "Panasonic Fan": "smart-fan",
      "Panasonic Television": "television",
      ODMFRONTLOADWM: "washing-maching",
      REFRIGERATOR: "refrigerator",
      "Panasonic Smart Plug": "smart-plug",
      "Panasonic Switch Device": "switch-device",
      "Panasonic door-phone": "door-phone",
    };
    return map[category] || "default-device";
  };

  return (
    <Box className="report-devices-page">
      {/* Heading */}
      <Box sx={{ pl: 0, mb: 1.5 }}>
        <SectionHeading sx={{ fontSize: 16, mb: 0.5 }}>
          Devices in {selectedData.spaceName}{" "}
          {selectedData.devices.length > 0
            ? `(${selectedData.devices.length})`
            : ""}
        </SectionHeading>
        <LabelText sx={{ color: "#9e9e9e", fontSize: 14 }}>
          Select an option to view device detail reports
        </LabelText>
      </Box>

      {/* Device selector */}
      <Box
        className="device-selector-scroll-wrap report-device-selector-col"
        sx={{ overflowX: "auto", overflowY: "visible", pb: 1, mb: 1 }}
      >
        {selectedData.devices.length === 0 ? (
          <Box className="noDeviceFound radius-10 light-gray">
            <Box className="text-box">
              <i className="no-device-icon"></i>
              <LabelText component="label">No device found</LabelText>
            </Box>
          </Box>
        ) : (
          <Box
            component="ul"
            className="tabs detail-tab reset-thumb scroll-set"
            sx={{ pl: { xs: "4px !important", sm: 0 }, pr: { xs: "4px !important", sm: 0 } }}
          >
            {selectedData.devices.map((mydevice, i) => (
              <li key={i} className="tab">
                <Link
                  to={"#"}
                  onClick={() => viewAcDetails(mydevice)}
                  className={Id === mydevice.deviceId ? "active" : ""}
                >
                  <i className={`tabs-icon ${getDeviceIconClass(mydevice.categoy)}`}></i>
                  <div className="title">{mydevice.deviceName}</div>
                </Link>
              </li>
            ))}
          </Box>
        )}
      </Box>

      {/* Device detail tabs */}
      {Id && selectedData && selectedData.devices.length > 0 ? (
        <Fragment>
          {/* Device log tabs — same component as SearchDevice */}
          <Box sx={{ mt: 1.5 }}>
            <AppTabs
              value={activeTab}
              onChange={(e, newValue) => {
                setActiveTab(newValue);
                setSelectedTab(availableTabs[newValue]);
              }}
              tabs={availableTabs?.map((label) => ({ label }))}
              variant="scrollable"
              scrollButtons="auto"
              tabsSx={{ mt: 1 }}
            />
          </Box>
          {/* Half-width separator before Device Details */}
          <Divider sx={{ mt: 2, mb: 2, width: "50%" }} />

          {(() => {
            const deviceDetail = device
              ? device.length > 1
                ? device[1]
                : device[0]
              : {} ?? {};
            switch (selectedTab) {
              case "Device Info":
                return (
                  <Box sx={{ mt: 2 }}>
                    <DeviceDetails
                      showSeparator={true}
                      compactLayout={true}
                      device={device}
                      deviceUsage={deviceUsage}
                      latestFirmwareData={latestFirmwareData}
                      firmwareData={firmwareData}
                      onBoardedHistoryData={onBoardedHistoryData}
                      diagnosticData={diagnosticData}
                      notifyOffboard={handleNotifyOffboard}
                      homeId={homeId}
                    />
                  </Box>
                );
              case "DAC Logs":
                return (
                  <DeviceDACLogs
                    getDeviceDACLogsData={getDeviceDACLogsData}
                    dacData={deviceLogs}
                    deviceDetails={deviceDetail}
                  />
                );
              case "Device Logs":
                return <DeviceUpdateLogs deviceDetails={deviceDetail} />;
              case "Connection Status Logs":
                return (
                  <DeviceConnDisconnLogs
                    getDeviceConnDisconnLogsData={getDeviceConnDisconnLogsData}
                    connectionStatusLogs={deviceLogs}
                    deviceDetails={deviceDetail}
                  />
                );
              case "Diagnostic Logs":
                return (
                  <DeviceDiagnostics
                    diagnosticData={deviceLogs}
                    setDialog={setDialog}
                    setDialogContents={setDialogContents}
                    deviceDetails={deviceDetail}
                    getDeviceDiagnosticsData={getDeviceDiagnosticsData}
                    downloadDeviceDiagnosticReport={downloadDeviceDiagnosticReport}
                  />
                );
              case "Status Logs":
                return (
                  <DeviceStatus
                    setDialog={setDialog}
                    setDialogContents={setDialogContents}
                    statusData={deviceLogs}
                    deviceDetails={deviceDetail}
                    getDeviceStatusData={getDeviceStatusData}
                    downloadDeviceStatusReport={downloadDeviceStatusReport}
                  />
                );
              default:
                return null;
            }
          })()}
        </Fragment>
      ) : null}

      <Dialog
        open={dialog}
        onClose={() => setDialog(false)}
        title={dialogContents?.title}
        showCloseButton
        actions={[{ label: "Close", variant: "ghost", onClick: () => setDialog(false) }]}
        sx={{ zIndex: "2400 !important" }}
        titleSx={{ backgroundColor: "#f4f4f4", fontSize: "16px !important" }}
      >
        <Box sx={{ mb: 2 }}>{getFormatedJSON(dialogContents?.data)}</Box>
      </Dialog>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  report: state.report,
  userRoleInfo: {
    level: state.auth.userLevel,
    roles: state.auth.userRoles,
  },
  user: state.user,
  tenant: state.tenant,
});

const mapDispatchToProps = (dispatch) => ({
  getDevice: (arg1, arg2, arg3, arg4, arg5) =>
    dispatch(getDevice(arg1, arg2, arg3, arg4, arg5)),
  getDeviceUsagebyId: (arg1) => dispatch(getDeviceUsagebyId(arg1)),
  getFirmwareHistory: (arg1) => dispatch(getFirmwareHistory(arg1)),
  getOnboardedHistory: (arg1) => dispatch(getOnboardedHistory(arg1)),
  getDeviceDiagnosticsData: (params, cb) => {
    dispatch(getDeviceDiagnosticsData(params, cb));
  },
  getDeviceDACLogsData: (params, cb) => {
    dispatch(getDeviceDACLogsData(params, cb));
  },
  downloadDeviceDiagnosticReport: (params, cb) => {
    dispatch(downloadDeviceDiagnosticReport(params, cb));
  },
  getDeviceConnDisconnLogsData: (deviceId, cb) => {
    dispatch(getDeviceConnDisconnLogsData(deviceId, cb));
  },
  getDeviceStatusData: (params, cb) => {
    dispatch(getDeviceStatusData(params, cb));
  },
  downloadDeviceStatusReport: (params, cb) => {
    dispatch(downloadDeviceStatusReport(params, cb));
  },
  getReportbyId: (homeId) => {
    dispatch(getReportbyId(homeId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportDevices);
